// src/services/transactionService.ts
import api from './api';

// Enhanced Transaction interface with additional fields
export interface Transaction {
  _id: string;
  type: 'buy' | 'sell' | 'transfer' | 'receive';
  token: string;
  amount: number;
  solAmount: number;
  status: 'pending' | 'completed' | 'failed';
  createdAt: string;
  txHash: string;
  fromAddress?: string;
  toAddress?: string;
  priceUsd?: number;
  fee?: number;
  blockTime?: number;
  confirmations?: number;
  tokenSymbol?: string;
  valueUsd?: number;
}

export const getUserTransactions = async (privyUserId: string): Promise<Transaction[]> => {
  try {
    const response = await api.get(`/transactions/user/${privyUserId}`);
    
    // Enhance transaction data with more details if available
    const transactions = response.data.map((tx: Transaction) => {
      // Calculate USD value if price is available but value isn't
      if (tx.priceUsd !== undefined && tx.valueUsd === undefined) {
        tx.valueUsd = tx.amount * tx.priceUsd;
      }
      
      // Use symbol from token if tokenSymbol isn't defined
      if (!tx.tokenSymbol && tx.token) {
        // Handle common token addresses with known symbols
        if (tx.token === 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v') {
          tx.tokenSymbol = 'USDC';
        } else if (tx.token === 'SOL' || tx.token === 'Solana') {
          tx.tokenSymbol = 'SOL';
        }
      }
      
      return tx;
    });
    
    return transactions;
  } catch (error) {
    console.error('Error fetching user transactions:', error);
    throw error;
  }
};

export const getTransactionDetails = async (txHash: string): Promise<Transaction> => {
  try {
    const response = await api.get(`/transactions/${txHash}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching transaction details:', error);
    throw error;
  }
};

export const createTransaction = async (transactionData: {
  privyUserId: string;
  type: 'buy' | 'sell' | 'transfer' | 'receive';
  token: string;
  amount: number;
  solAmount: number;
  txHash: string;
  fromAddress?: string;
  toAddress?: string;
  status?: 'pending' | 'completed' | 'failed';
  priceUsd?: number;
  fee?: number;
  tokenSymbol?: string;
}) => {
  try {
    const response = await api.post('/transactions', transactionData);
    return response.data;
  } catch (error) {
    console.error('Error creating transaction:', error);
    throw error;
  }
};